<template>
  <el-dialog
    :title="title"
    :visible="dialogFormVisible"
    :before-close="handleClose"
    width="60%"
  >
    <table-form
      :dataSource="dataSource"
      ref="form"
      :tableData="formData"
      :disable="disabled"
    ></table-form>
    <!-- <div class="upload">
      <el-table :data="dataUp" style="width: 100%">
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="title" label="材料名称" width="150"></el-table-column>
        <el-table-column prop="oldFile" label="附件名称" width="auto"></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <a href="javascript:void(0);" class="input">
              上传
              <input type="file" class="file" @change="getFile($event,scope)" accept />
            </a>
          </template>
        </el-table-column>
        <el-table-column label="下载附件" width="100">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              :disabled="scope.row.newFile?false:true"
              @click="downFile(scope.row)"
            >下载</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div> -->
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" class="pull-left " @click="allDisabled"
        >编辑</el-button
      >
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import TableForm from "common/components/form/tableForm1";
import { step3 } from "@/conf/newAgency";
import {
  addUpContactFin,
  upload,
  downLoadCommon,
  addPersonInfo,
  updateFinanceLinkman,
} from "common/js/api";
export default {
  components: {
    TableForm,
  },

  props: ["dialogVisible", "title", "tableData", "detailId", "codeId", "type"], //falg判断是联系人、负责人

  data() {
    return {
      dataSource: [],
      dialogFormVisible: false,
      formData: {},
      dataUp: [],
      disabled: true,
    };
  },

  mounted() {
    this.dataSource = this.$lodash.cloneDeep(step3[0]);
  },

  methods: {
    allDisabled() {
      console.log(this.disabled);
      this.disabled = false;
      if (this.disabled == false) {
        this.$message({
          message: "已开启编辑模式",
          type: "success",
        });
      }
    },
    async downFile(row) {
      const fileData = row.newFile.split("/");
      const suffix = fileData[1].split(".");
      await downLoadCommon(fileData[0], suffix[1], row.oldFile, suffix[0]);
    },

    handleClose() {
      this.dialogFormVisible = false;
      this.resetForm();
      this.$emit("closeDialog");
    },

    handlerSubmitClose() {
      this.dialogFormVisible = false;
      this.resetForm();
      this.$emit("reload");
    },

    async submit() {
      const isValidate = this.$refs.form.submitForm();
      if (!isValidate) return false;
      let form = this.$refs.form.form;
      form.type = this.type;
      console.log(form);
      // 业务规范承诺书;
      // form.identityFileOrignName = this.dataUp[0].oldFile;
      // form.identityFileStorePath = this.dataUp[0].newFile;
      // code id
      form.personType = 1;
      form.institutionCode = this.codeId;
      if (this.title.includes("编辑")) {
        form.id = this.tableData.id;
      } else {
        form.id = 0;
      }
      if (this.title.includes("添加")) {
        await addPersonInfo(form);
      } else {
        await updateFinanceLinkman(form);
      }
      // await addUpContactFin(this.title, form);
      this.$message({
        message: `${this.title}成功!`,
        type: "success",
      });
      this.handlerSubmitClose();
    },

    getFile(event, scope) {
      this.file = event.target.files[0];
      if (this.file) {
        this.uploadForm(event);
      }
    },

    async uploadForm(event) {
      event.preventDefault();
      let formData = new FormData();
      formData.append("file", this.file);
      const result = await upload(formData);

      this.dataUp[0].oldFile = result.result.orignName;
      this.dataUp[0].newFile = result.result.storePath;

      this.$message({
        message: "上传成功",
        type: "success",
      });
    },

    resetForm() {
      this.formData = {};
      this.dataUp.forEach((item) => {
        item.oldFile = "";
        item.newFile = "";
      });
    },

    // editSetDetail(tableData) {
    //   this.dataUp[0].oldFile = tableData.identityFileOrignName;
    //   this.dataUp[0].newFile = tableData.identityFileStorePath;
    // },
  },

  watch: {
    dialogVisible(newValue) {
      this.dialogFormVisible = newValue;
      if (newValue && this.title.includes("编辑")) {
        // this.editSetDetail(this.tableData);
        this.disabled = true;
      }
      if (this.title.includes("添加")) {
        this.disabled = false;
      }
    },

    tableData: {
      handler(newValue) {
        this.formData = newValue;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.upload {
  padding-top: 30px;
}

/*input*/
.file_name {
  width: 50%;
  text-indent: 10px;
  border: 1px solid #ccc;
  height: 30px;
}

a.input {
  width: 70px;
  /* border-radius: 5px; */
  height: 30px;
  margin-top: 1px;
  vertical-align: top;
  line-height: 28px;
  /* background: #409EFF; */
  /* background: #3091d1; */
  text-align: center;
  display: inline-block;
  overflow: hidden;
  position: relative;
  vertical-align: bottom;
  text-align: left;
}

/* a.input:hover {
  background: #66b1ff;
  color: #ffffff;
} */

a {
  text-decoration: none;
  color: #3165ff;
  position: absolute !important;
  left: 10px;
  top: 10px;
  font-size: 13px;
}

.file {
  opacity: 0;
  /*设置此控件透明度为零，即完全透明*/
  filter: alpha(opacity=0);
  /*设置此控件透明度为零，即完全透明针对IE*/
  font-size: 100px;
  cursor: pointer;
  position: absolute;
  /*绝对定位，相对于 .input */
  top: 0;
  right: 0;
}
</style>
